import { get } from 'lodash'
import { graphql } from 'gatsby'
import React from 'react'

import { Base, Footer, Navigation } from 'components/common'
import AboutPageTemplate from 'templates/about-page'

const getNode = obj => get(obj, 'edges.0.node', {})

export default function AboutPage({ data = {} }) {
  const { frontmatter: globals } = getNode(data.globals)
  const { html, frontmatter: content } = getNode(data.about)

  const {
    accreditations,
    footer,
    navigation,
  } = globals

  const {
    heroImage,
    heroHeading,
  } = content

  const { phoneNumber } = footer

  return (
    <Base>
      <Navigation {...navigation} phoneNumber={phoneNumber} />
      <AboutPageTemplate
        accreditations={accreditations}
        heroImage={heroImage}
        heroHeading={heroHeading}
        aboutText={html}
      />
      <Footer {...footer} />
    </Base>
  )
}

export const pageQuery = graphql`
query AboutPageQuery {
  globals: allMarkdownRemark(
    filter: { frontmatter: { templateKey: { eq: "globals" } }}
  ) {
    edges {
      node {
        frontmatter {
          accreditations {
            alt
            image {
              childImageSharp {
                fluid(maxWidth: 400, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          footer {
            logo {
              childImageSharp {
                fluid(maxWidth: 400, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            emailAddress
            phoneNumber
          }
          navigation {
            logo {
              alternativeText
              image {
                childImageSharp {
                  fluid(maxWidth: 400, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            pages {
              label
              path
            }
          }
        }
      }
    }
  }

  about: allMarkdownRemark(
    filter: { frontmatter: { templateKey: { eq: "about-page" } }}
  ) {
    edges {
      node {
        html
        frontmatter {
          heroHeading
          heroImage {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 80) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
}
`
